
    import Vue from 'vue';
    import {Prop} from "vue-property-decorator";
    import Component from "vue-class-component";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
	import {ls} from "@/CultureService";

    @Component({
        components: {
            LoadingSpinner
        }
    })
    export default class TableEmptySlot extends Vue{
        @Prop({default: false})
        loading!: boolean;
        
        @Prop({default: ls.Global_Table_Placeholder_NoDocuments})
        emptyText!: string;

        @Prop({default: ls.Global_Placeholder_Searching})
        loadingText!: string;
    }
